import { render } from "./AiCircleLoader.vue?vue&type=template&id=436270a9&scoped=true"
const script = {}

import "./AiCircleLoader.scss?vue&type=style&index=0&id=436270a9&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-436270a9"]])

export default __exports__